import { Button, DataSource, Layout, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTieredStopChargesTable extends Layout {
    buttonAdd: Button;
    buttonSearch: Button;
    sourceTieredCharge: DataSource;
    sourceTieredChargeTable: DataSource;
    switchActive: Switch;
    tableTieredCharges: Table;
    textboxCurrencyType: Textbox;
    textboxDescription: Textbox;
    textboxTableId: Textbox;
}
